// extracted by mini-css-extract-plugin
export default {"title":"AddPost_title__sP4hx","image":"AddPost_image__+X2yS","tags":"AddPost_tags__w-qC8","editor":"AddPost_editor__zJX-u","buttons":"AddPost_buttons__BGkFi"};